import { render, staticRenderFns } from "./vehicleRefuelConsumption.vue?vue&type=template&id=54b92e58"
import script from "./vehicleRefuelConsumption.vue?vue&type=script&lang=js"
export * from "./vehicleRefuelConsumption.vue?vue&type=script&lang=js"
import style0 from "./vehicleRefuelConsumption.vue?vue&type=style&index=0&id=54b92e58&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports